import { z } from 'zod';

export const userLikeSchema = z.object({
  type: z.literal('user'),
  id: z.string(),
  email: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  fullNameOrEmail: z.string().nullable(),
  displayName: z.string().nullable().optional(),
  coachName: z.string().optional(),
  shortCode: z.string().nullable().optional(),
});

/**
 * Represents any entity with a UUID, a first name, and a last name.
 */
export type UserLike = z.infer<typeof userLikeSchema>;
